// extracted by mini-css-extract-plugin
module.exports = {"container":"bio-module--container--31LR7","avatar":"bio-module--avatar--3B4ef","author":"bio-module--author--3kXX5","jobTitle":"bio-module--job-title--UWSlq"};